import React from 'react'
import { Link } from 'react-router-dom'
import { FaLeaf, FaCogs, FaWarehouse, FaShip, FaUsers } from 'react-icons/fa'
import HeroIcon from './HeroIcon'

const HERO_IMAGES = [
  { image: '/assets/grain-handling.png' },
  { image: '/assets/food-processing.png' },
  { image: '/assets/warehousing.png' },
  { image: '/assets/food-storage.png' },
  { image: '/assets/port-services.png' },
  { image: '/assets/consumer.png' },
]

const HERO_ICONS = [
  {
    icon: FaLeaf,
    label: 'HARVEST',
    desc: 'Our services are there from the beginning.',
  },
  {
    icon: FaCogs,
    label: 'PROCESSING',
    desc: 'Our services are there through production.',
  },
  {
    icon: FaWarehouse,
    label: 'STORAGE',
    desc: 'We are there to protect your stored products and facilities.',
  },
  {
    icon: FaShip,
    label: 'TRANSPORT & EXPORT',
    desc: 'We proudly serve all Texas ports of entry.',
  },
  {
    icon: FaUsers,
    label: 'TO CONSUMER',
    desc: 'Delivering quality. Earning trust.',
  },
]

export default function Hero() {
  return (
    <section className="hero" aria-label="Specialty pest solutions">
      <div className="hero__stage">
        <div className="hero__panels">
          <div className="hero__panels-strip">
            <div className="hero__panels-row">
              {HERO_IMAGES.map((item, index) => {
                const isFirst = index === 0
                const isLast = index === HERO_IMAGES.length - 1
                return (
                  <div
                    key={item.image}
                    className={`hero-panel${isFirst ? ' hero-panel--first' : ''}${isLast ? ' hero-panel--last' : ''}`}
                    style={{ zIndex: index + 1 }}
                  >
                    <div className="hero-panel__media" aria-hidden="true">
                      <div className="hero-panel__clip">
                        <img src={item.image} alt="" />
                        {index > 0 && <div className="hero-panel__seam" aria-hidden="true" />}
                      </div>
                    </div>
                  </div>
                )
              })}
              <div className="hero__panels-fade" aria-hidden="true" />
            </div>
          </div>
        </div>

        <div className="hero__scrim" aria-hidden="true" />

        <div className="hero__copy">
          <h1 className="hero__headline">Specialty Pest Solutions.</h1>
          <p className="hero__headline hero__headline--red">Protecting What Matters.</p>
          <p className="hero__subtext">
            Aegis Professional Services is a specialty pest services provider delivering customized,
            science-based solutions for the industrial, commercial, and agricultural sectors.
          </p>
          <Link to="/contact" className="hero__cta">
            Request a Quote <span aria-hidden="true">&gt;</span>
          </Link>
        </div>

        <div className="hero__icon-band">
          <div className="hero__icon-row">
            {HERO_ICONS.map((item) => (
              <div key={item.label} className="hero-icon-slot">
                <HeroIcon icon={item.icon} label={item.label} />
                <div className="hero-icon-slot__text">
                  <p className="hero-icon-slot__label">{item.label}</p>
                  <p className="hero-icon-slot__desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
